import orbAsset from './assets/orb.png';
export default orbAsset;
